<chart-details-layout [chartDetails]="chartDetails"
                      [isLoading]="isLoading"
                      [showFormButtons]="showFormButtons"
                      (save)="onSaveSettings()"
                      (cancel)="onRevertSettings()">
    <global-search-term-chart chart [showTitle]="false"></global-search-term-chart>
    <base-details detailsComponent
                  *ngIf="!isLoading"
                  [chartDetails]="chartDetails"
                  [generalSettings]="config?.generalSettings"
                  (generalSettingsChange)="onGeneralSettingsChange($event)">
        <div #filterContent>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group input-group has-feedback" style="position: relative;">
                        <label class="control-group input-group-addon" for="selectedMin">Min Used
                            <button class="info-btn"
                                    type="button"
                                    [attr.title]="info('minUsed')"
                                    (click)="onInfoClick($event, 'minUsed')">
                                i
                            </button>
                        </label>
                        <input id="selectedMin"
                               name="selectedMin"
                               type="number"
                               [(ngModel)]="selectedMinUsed"
                               class="form-control"
                               (click)="hideTooltip()" />

                        <div class="click-tooltip"
                             *ngIf="isTooltipVisible('minUsed')"
                             (click)="hideTooltip()">
                            {{ info('minUsed') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </base-details>
</chart-details-layout>